export default __webpack_public_path__ + "static/media/longTerm_popupImage.81d3bd8a.png";